import { useEffect, useState } from 'react';
import { AritoFormV2, AritoIcon, BottomActionBarV2, DialogV2 } from '@/components/custom/erp';
import { FormSchema, FormValues, initialFormValues } from '../../schema';
import { Phi, PhiInput } from '@/types/schemas';
import { BasicInfoTab } from './BasicInfoTab';
import { useFormState } from '../../hooks';
import { FormMode } from '@/types/form';

interface FormDialogProps {
  formMode: FormMode;
  open: boolean;
  initialData?: Phi;
  onSubmit?: (data: PhiInput) => void;
  onClose: () => void;
  onAdd?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  onCopy?: () => void;
  zIndex?: number;
}

const FormDialog = ({
  open,
  onClose,
  onSubmit,
  formMode,
  initialData,
  onAdd,
  onEdit,
  onDelete,
  onCopy,
  zIndex
}: FormDialogProps) => {
  const [isFormDirty, setIsFormDirty] = useState<boolean>(false);
  const { state, actions } = useFormState(initialData);

  useEffect(() => {
    if (!open) {
      setIsFormDirty(false);
    }
  }, [open]);

  const handleSubmit = (data: FormValues) => {
    onSubmit?.({
      ...data,
      nhom_phi_1: state.nhomPhi1?.uuid,
      nhom_phi_2: state.nhomPhi2?.uuid,
      nhom_phi_3: state.nhomPhi3?.uuid,
      bo_phan: state.boPhan?.uuid
    });
    setIsFormDirty(false);
    onClose();
  };

  return (
    <>
      <DialogV2
        open={open}
        onClose={onClose}
        title={formMode === 'add' ? 'Mới' : formMode === 'edit' ? 'Sửa' : 'Danh mục phí'}
        maxWidth='xl'
        disableBackdropClose={false}
        disableEscapeKeyDown={true}
        titleIcon={<AritoIcon icon={281} />}
        zIndex={zIndex}
      >
        <AritoFormV2
          mode={formMode}
          hasAritoActionBar={false}
          schema={FormSchema}
          onSubmit={handleSubmit}
          onClose={onClose}
          initialData={(initialData || initialFormValues) as FormValues}
          className='w-[800px] overflow-y-auto'
          headerFields={
            <div onChange={() => setIsFormDirty(true)}>
              <BasicInfoTab formMode={formMode} formState={{ state, actions }} />
            </div>
          }
          bottomBar={
            <BottomActionBarV2
              mode={formMode}
              onClose={onClose}
              onAdd={onAdd}
              onEdit={onEdit}
              onDelete={onDelete}
              onCopy={onCopy}
            />
          }
        />
      </DialogV2>
    </>
  );
};

export default FormDialog;
